import { tracs_api } from "../../services/api.interceptor";
import { TocRole } from "../interfaces/configurationmodels";


class ConfigurationService{
    getMenus(){
        return tracs_api.post(process.env.REACT_APP_USER_API +"Configuration/GetMenus");
    }

    getTocMenus(){
        return tracs_api.post(process.env.REACT_APP_USER_API +"Configuration/GetTocMenus");
    }

    updateTocMenus(tocRoleMenus:any[]){
       
        return tracs_api.post(process.env.REACT_APP_USER_API +"Configuration/UpdateTocMenu",tocRoleMenus);
    }

    GetTocDataTables(){
        return tracs_api.post(process.env.REACT_APP_USER_API +"Configuration/GetTocDataTables");
    }

    UpdateTocDatatable(TocDataTables:any[]){
       
        return tracs_api.post(process.env.REACT_APP_USER_API +"Configuration/UpdateTocDatatable",TocDataTables);
    }

    GetTocOutputTables(){
        return tracs_api.post(process.env.REACT_APP_USER_API +"Configuration/GetTocOutputTables");
    }

    UpdateTocOutputtable(TocOutputTables:any[]){
       
        return tracs_api.post(process.env.REACT_APP_USER_API +"Configuration/UpdateTocOutputtable",TocOutputTables);
    }
}

export default new ConfigurationService();